import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'evolucao-semanal-treino',
    title: 'Evolução semanal de treino',
    description: 'Check-in semanal para acompanhar a performance, recuperação e motivação dos alunos.',
    indicatedFor: 'Personal trainers',
    stepsCount: 1,
    questionsSummary: ['Treinos realizados', 'Qualidade do sono', 'Nível de energia', 'Feedback geral'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Evolução semanal de treino',
        active: false,
        allow_multiple_answers: true,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Como foi sua semana?',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'number',
                        label: 'Quantos treinos você realizou esta semana?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'scale',
                        label: 'Como você avalia a qualidade do seu sono esta semana?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Péssimo',
                            maxLabel: 'Excelente',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 3,
                        type: 'scale',
                        label: 'Como estava seu nível de energia durante os treinos?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Muito baixo',
                            maxLabel: 'Máximo',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 4,
                        type: 'text',
                        label: 'Algum comentário ou ponto de atenção para o personal?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
};
